import { useTranslation } from "react-i18next"

import { MonitorPlay } from "@/components/icons"

import { CollapsibleManagementSection } from "./collapsible-management-section"
import { SlideHubConfigPanel } from "./slide-hub-config-panel"

/**
 * "Slide Hub presenting" management section.
 *
 * Presenter mode availability toggles, rendered by ``SlideHubConfigPanel``.
 */
export function SlideHubManagementSection() {
  const { t } = useTranslation()

  return (
    <CollapsibleManagementSection
      icon={<MonitorPlay className="size-5" />}
      id="slide-hub"
      storageKey="admin-management-slide-hub-expanded"
      title={t("adminDashboard.systemConfig.slideHub.sectionTitle", {
        defaultValue: "Slide Hub presenting",
      })}
    >
      <div className="space-y-3">
        <p className="text-muted-foreground text-xs">
          {t("adminDashboard.systemConfig.slideHub.sectionDescription", {
            defaultValue:
              "Choose which presenter modes users can start from Slide Hub. Disabling a mode hides it for everyone in this tenant.",
          })}
        </p>
        <SlideHubConfigPanel />
      </div>
    </CollapsibleManagementSection>
  )
}
